import { formatDateInput } from 'utils';

export default {
  refreshOn: ({ startDate, endDate }) => ([startDate, endDate]),
  'CustomCalendarHeaderInputs.HeaderWrapper.StartDate.Input': ({ selectedDate }, outlet) => {
    outlet({ selectedDate, action: 'changeStartDate' })
  },
  'CustomCalendarHeaderInputs.HeaderWrapper.EndDate.Input': ({ selectedDate }, outlet) => {
    outlet({ selectedDate, action: 'changeEndDate' })
  },
  'CustomCalendarHeaderInputs.HeaderWrapper.StartDate': ({ }, outlet) => {
    outlet({ action: 'selectStartDate' })
  },
  'CustomCalendarHeaderInputs.HeaderWrapper.EndDate': ({ }, outlet) => {
    outlet({ action: 'selectEndDate' })
  },
}